/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Digital_PhotographyInputs */

const en_listing_category_digital_photography = /** @type {(inputs: Listing_Category_Digital_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photography`)
};

const es_listing_category_digital_photography = /** @type {(inputs: Listing_Category_Digital_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografía`)
};

const fr_listing_category_digital_photography = /** @type {(inputs: Listing_Category_Digital_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photographie`)
};

const de_listing_category_digital_photography = /** @type {(inputs: Listing_Category_Digital_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografie`)
};

const ja_listing_category_digital_photography = /** @type {(inputs: Listing_Category_Digital_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写真`)
};

const zh_listing_category_digital_photography = /** @type {(inputs: Listing_Category_Digital_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摄影`)
};

const ar_listing_category_digital_photography = /** @type {(inputs: Listing_Category_Digital_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصوير`)
};

const id_listing_category_digital_photography = /** @type {(inputs: Listing_Category_Digital_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografi`)
};

const it_listing_category_digital_photography = /** @type {(inputs: Listing_Category_Digital_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografia`)
};

const ru_listing_category_digital_photography = /** @type {(inputs: Listing_Category_Digital_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фотография`)
};

const pt_listing_category_digital_photography = /** @type {(inputs: Listing_Category_Digital_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografia`)
};

const ko_listing_category_digital_photography = /** @type {(inputs: Listing_Category_Digital_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사진`)
};

/**
* | output |
* | --- |
* | "Photography" |
*
* @param {Listing_Category_Digital_PhotographyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_digital_photography = /** @type {((inputs?: Listing_Category_Digital_PhotographyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Digital_PhotographyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_digital_photography(inputs)
	if (locale === "es") return es_listing_category_digital_photography(inputs)
	if (locale === "fr") return fr_listing_category_digital_photography(inputs)
	if (locale === "de") return de_listing_category_digital_photography(inputs)
	if (locale === "ja") return ja_listing_category_digital_photography(inputs)
	if (locale === "zh") return zh_listing_category_digital_photography(inputs)
	if (locale === "ar") return ar_listing_category_digital_photography(inputs)
	if (locale === "id") return id_listing_category_digital_photography(inputs)
	if (locale === "it") return it_listing_category_digital_photography(inputs)
	if (locale === "ru") return ru_listing_category_digital_photography(inputs)
	if (locale === "pt") return pt_listing_category_digital_photography(inputs)
	return ko_listing_category_digital_photography(inputs)
});